var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-page-learning-unit-info',{attrs:{"mode":"instructor","disabled":_vm.disabled,"editable":_vm.editable}})}
var staticRenderFns = []

export { render, staticRenderFns }